module.exports = __webpack_public_path__ + "static/img/rank05.d27fd40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/rank05.jpg
// module id = vqvZ
// module chunks = 76